import { SxProps } from "@mui/material";
import * as CSS from "csstype";

export type TypeSizeIconButton = "mini" | "small" | "medium" | "large";
export type TypeVariantIconButton =
  | "contained"
  | "outlined"
  | "ghost"
  | "standard";

export interface IVaButton {
  id?: string;
  variant?: TypeVariantIconButton | "link" | "text";
  children?: React.ReactNode;
  fullWidth?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onMouseEnter?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onMouseLeave?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  sx?: SxProps;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  iconSx?: SxProps;
  size?: TypeSizeIconButton;
  buttonColor?: string;
  startIconSx?: SxProps;
  endIconSx?: SxProps;
  color?: CSS.PropertiesFallback<number | string>["backgroundColor"];
  className?: string;
  type?: "button" | "submit" | "reset";
  noAnimation?: boolean;
}

//button
export const buttonHeight = 40;
export const buttonHeightSmall = 36;
export const buttonHeightLarge = 48;
export const buttonHeightMini = 28;
